export const ergonomicKeysMap = new Map([
    ['default', 'Default'],
    ['hold_1_button', 'Long Press 1 buttons'],
    ['hold_2_buttons', 'Long Press 2 buttons'],
]);
